const getters = {
	isGuest: state => state.user.userId == null,
	isKiosk: state => state.kiosk.is, // 是否為前台點餐
	isOpen: state => {
		const { openInfo } = state.store
		if (!openInfo) return false
		if (openInfo.open) return true
		return false
	},
	isBooking: state => {
		const { openInfo } = state.store
		if (!openInfo) return false
		return !!openInfo.bookingSwitch
	},
	isOnsiteTake: state => {
		const { openInfo } = state.store
		if (!openInfo) return false
		return !!openInfo.onsiteTakeSwitch
	},
	isMobileOrder: state => {
		const { openInfo } = state.store
		return !!openInfo.mobileOrderSwitch
	},
	canBuy: state => {
		const { openInfo } = state.store
		if (state.kiosk.is) return true
		if (!openInfo) return false

		// 檢查基本條件：營業中或開放預約，且開啟手機點餐
		const baseCanBuy = !!(
			(openInfo.open || openInfo.bookingSwitch) &&
			openInfo.mobileOrderSwitch
		)

		if (!baseCanBuy) return false

		const mobilePickupMethod = openInfo.mobilePickupMethod
		if (!mobilePickupMethod) return false

		const isStoreOpen = openInfo.open
		let availableMethods = Object.entries(mobilePickupMethod)
			.filter(([key, value]) => value.methodSwitch)
			.map(([key]) => key)

		if (!isStoreOpen) {
			availableMethods = availableMethods.filter(method => method !== 'dineIn')
		}

		return availableMethods.length > 0
	},
}
export default getters
